import { parseNestError } from '@store/reducers/dashboard/utils'
import {
  PROJECTS_LIMIT_REACHED,
  upgradeToast,
} from '@store/reducers/limitReached'
import {
  ErrorNotification,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import type { ProjectActions } from '../actions'

export function* moveTo({
  payload,
}: ReturnType<typeof ProjectActions.moveToWorkspace>) {
  const { id, folderId, workspaceId } = payload

  try {
    yield call(NestClient.projects.moveTo, { ids: [id] }, workspaceId, folderId)
    yield put(
      notificationActionCreators.setCustomNotification({
        text: 'Project moved',
        toastContainerId: 'secondary',
        type: 'gray',
      })
    )
  } catch (e) {
    const message = parseNestError(e)

    if (message === PROJECTS_LIMIT_REACHED) {
      yield* upgradeToast(message)

      return
    }

    yield put(ErrorNotification(message))
  }
}
